import {WlFavoriteEvent} from "../../../common/ts/webcomponents/events/WlFavorite";
import {connect} from "../../../common/ts/connect";
import PageGallery from "../../../common/ts/components/PageGallery";
import {serviceContainer} from "../serp/SerpServiceContainerFactory";
import {ToggleDescription} from "../serp/subscribers/ToggleDescription";

const wlFavoriteComponentSelector = 'wl-favorite';


window.onload = () => {
    new PageGallery(".swiper-container:has(.swiper-wrapper)");
    serviceContainer.get(ToggleDescription.name).init();
    connect(() => {
        const favoritesSubtitleNumberElement = document.querySelector('.js-favorites-subtitle-number');
        document.querySelectorAll(wlFavoriteComponentSelector).forEach((item) => {
            item.addEventListener(WlFavoriteEvent.type, (e) => {
                const event: WlFavoriteEvent = e as WlFavoriteEvent;
                if (!event.isSelected) {
                    const listingToDelete: string = event.listingId;
                    const listingElement = document.querySelector(`.snippet-listing[data-id="${listingToDelete}"]`);
                    listingElement?.classList.add('hidden');
                }
                if (favoritesSubtitleNumberElement) {
                    favoritesSubtitleNumberElement.textContent = event.currentFavorites.listings.size.toString();
                }
            });
        });
    });
}
